<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HNn9nM/tc-custom/9781685624651.jpg?1705056345810" alt="This image is the cover for the book The Unique Friendship of Grover and Steve"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Unique Friendship of Grover and Steve
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'>On the Great Plains, we find Grover, a donkey and Steve, an ostrich, who are the best of friends despite their differences.</p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br/></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'>The other animals on the plains just cannot understand how they are even friends. Donkeys and ostriches are just too different!</p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br/></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'>For Grover and Steve, while there are many differences between the two, what's most important to them is the bond of friendship.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Cherry, Buffie Biddle
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><strong><span style="font-size:11px;">Author:</span></strong></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><span style="font-size:11px;">Lee Cherry is the author of <em>The Unique Friendship of Grover and Steve</em>, his first book. He wanted to create a children&rsquo;s book with the message that regardless of our differences, we can all be friends, and do so in a way that children would understand. Lee attended the University of Central Florida and graduated with a degree in Business Administration. He resides in Florida with his wife and three children.</span></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><br></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><strong><span style="font-size:11px;">Illustrator: </span></strong></p><p style='margin:0cm;font-size:15px;font-family:"Grotesque Light",sans-serif;'><span style="font-size:11px;">Barbara &ldquo;Buffie&rdquo; Biddle is the illustrator of <em>The Unique <span style="font-size:11px;"><em>Friendship</em></span> of Grover and Steve</em>. She is both an author and illustrator of a variety of children&rsquo;s books. From an early age, Buffie loved drawing, painting, and making up stories and telling tales. Buffie attended Moore College of Art and Design and graduated from West Chester University with a degree in Fine Art and a minor in Special Education. Buffie resides in Pennsylvania with her family. </span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?910eafb6